module.exports = __webpack_public_path__ + "static/media/benefit_3.c8efc780.svg";